import React from 'react';
import About from '../components/About';
import WhyChooseUs from '../components/WhyChooseUs';
import MissionVision from '../components/MissionVision';
import CoreValues from '../components/CoreValues';
import CompanyTimeline from '../components/CompanyTimeline';
import TeamSection from '../components/TeamSection';
import TechStack from '../components/TechStack';

const AboutPage = () => {
  return (
    <main className="pt-20">
      <About />
      <MissionVision />
      <CoreValues />
      {/* <CompanyTimeline /> */}
      <TechStack />
      <TeamSection />
      <WhyChooseUs />
    </main>
  );
};

export default AboutPage;
